import {inject, Injectable} from '@angular/core';
import {RecordData, RecordsDataRequestQueryParams} from "../../../../../core/types/records-table.types";
import {Pageable} from "../../../../../core/types/pagable.types";
import {PulseReportChartApiService} from "./pulse-report-chart-api.service";

@Injectable({
  providedIn: 'root'
})
export class PulseReportChartService {
  private pulseReportChartApiService: PulseReportChartApiService = inject(PulseReportChartApiService);

  public getRecordTableChartData(path: string, queryParams: RecordsDataRequestQueryParams): Promise<Pageable<RecordData>> {
    return new Promise((resolve, reject) => {
      this.pulseReportChartApiService.getRecordTableChartData(path, queryParams).subscribe({
        next: (recordsTableData: Pageable<RecordData>) => resolve(recordsTableData),
        error: (error) => reject(error)
      })
    })
  }
}
